






import { AngularAlexMap } from '@/angular/angular-alex-map';
import { Component, Vue } from 'vue-property-decorator';
import Main from '@/views/Main.vue';
import '@/assets/alex.min';
import { appName } from '@/angular/angular-alex-map';

@Component({
  components: {
    Main
  },
})
export default class App extends Vue {
  mounted(): void {
    AngularAlexMap.createAngularApp();
    window.angular.element(() => {
      window.angular.bootstrap(document, [appName]);
    });
  }
}
